export const singleSignOnStatusOptions = [
  { value: "enabled", label: "Enabled" },
  { value: "disabled", label: "Disabled" },
];

export const certificatePlaceholder = `Paste your X.509 certificate here (PEM format)

-----BEGIN CERTIFICATE-----
MIIDXTCCAkWgAwIBAgIJAL...
-----END CERTIFICATE-----`;
